import React, { useState, useEffect, useCallback } from "react";
import { apiService } from "../../../components/Config/api.service";
import { notify } from "../../../components/Utils/Notifications"; 

const FinalSettlement = ({ setActiveTab, employee, currentContract, finalSettlementId, refreshRecap, handleDeleteFinalSettlement }) => {
  const [departureReasons, setDepartureReasons] = useState([]);
  const [allIndemnities, setAllIndemnities] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [indemnities, setIndemnities] = useState([]);
  const [checked, setChecked] = useState(true);
  const [exitDate, setExitDate] = useState("");
  const [finalSettlementData, setFinalSettlementData] = useState(null);
  const isDraft = finalSettlementData?.state === "draft" || !finalSettlementData;
  // Factorise la récupération des données de base
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiService.getElement("/departure_reasons");
        setDepartureReasons(res.data.departure_reasons || []);
        setAllIndemnities(res.data.indemnity || []);
      } catch {
        setDepartureReasons([]);
        setAllIndemnities([]);
      }
    };
    fetchData();
  }, []);

  // Factorise la récupération du final settlement
  useEffect(() => {
    const fetchFinalSettlement = async () => {
      if (finalSettlementId) {
        const res = await apiService.getElementById("/final_settlement", finalSettlementId);
        console.log("Final Settlement Data:", res.data);
        const data = res.data.final_settlement;
        setFinalSettlementData(data);
        setSelectedReason(data.departure_reason_id?.toString() || "");
        setExitDate(data.exit_date || "");
      } else {
        setFinalSettlementData(null);
        setSelectedReason("");
        setExitDate("");
        setIndemnities([]);
      }
    };
    fetchFinalSettlement();
  }, [finalSettlementId]);

  

  // Fonction utilitaire pour filtrer les indemnités
  const getFilteredIndemnities = useCallback(() => {
    if (selectedReason && exitDate && allIndemnities.length > 0) {
      return allIndemnities
        .filter(i => i.departure_reason_ids.includes(Number(selectedReason)))
        .map(i => ({
          id: i.id,
          label: i.name,
          field: i.field_name,
          amount: finalSettlementData && i.field_name && finalSettlementData[i.field_name] !== undefined
            ? finalSettlementData[i.field_name]
            : ""
        }));
    }
    return [];
  }, [selectedReason, exitDate, allIndemnities, finalSettlementData]);

  useEffect(() => {
    setIndemnities(getFilteredIndemnities());
  }, [selectedReason, exitDate, allIndemnities, finalSettlementData, getFilteredIndemnities]);

  
  // Met à jour automatiquement les indemnités quand les dépendances changent
//   useEffect(() => {
//   const ready =
//     employee?.id &&
//     currentContract?.id &&
//     selectedReason &&
//     exitDate;

//   if (!ready) return;

//   const payload = {
//     employee_id: employee.id,
//     contract_id: currentContract.id,
//     departure_reason_id: selectedReason,
//     exit_date: exitDate,
//     action: finalSettlementData ? "save" : "create",
//     settlement_id: finalSettlementData?.id,
//   };

//   apiService.saveElement("/final_settlement", payload)
//     .then(res => setFinalSettlementData(res.data.final_settlement))
//     .catch(err => console.error("Erreur lors de la création/mise à jour du final settlement", err));
// }, [employee, currentContract, selectedReason, exitDate]);

const recalculateIndemnities = async () => {
  const ready =
    employee?.id &&
    currentContract?.id &&
    selectedReason &&
    exitDate;

  if (!ready) {
    notify("Veuillez remplir tous les champs obligatoires.", "", 3);
    return;
  }

  const payload = {
    employee_id: employee.id,
    contract_id: currentContract.id,
    departure_reason_id: selectedReason,
    exit_date: exitDate,
    action: finalSettlementData ? "save" : "create",
    settlement_id: finalSettlementData?.id,
  };

  try {
    const res = await apiService.saveElement("/final_settlement", payload);
    setFinalSettlementData(res.data.final_settlement);
    notify("Indemnités recalculées", "", 2);
  } catch (err) {
    notify("Erreur lors du recalcul", "", 3);
  }
};

  
  const handleIndemnityChange = (index, field, value) => {
    setIndemnities(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  // const handleRemoveIndemnity = (index) => {
  //   setIndemnities(prev => prev.filter((_, i) => i !== index));
  // };

  
  const handleFinalSettlement = (action = "validate") => async (e) => {
  e.preventDefault();
  if (!selectedReason) return alert("Veuillez sélectionner un motif de départ.");
  if (!exitDate) return alert("Veuillez sélectionner une date de sortie.");

  const modifiedIndemnities = indemnities
    // .filter(item => {
    //   if (!item.field || !finalSettlementData) return false;
    //   const initial = finalSettlementData[item.field];
    //   return String(item.amount) !== String(initial ?? "");
    // })
    .map(item => ({
      id: item.id,
      field: item.field,
      amount: item.amount
    }));

  console.log(indemnities)

  const payload = {
    employee_id: employee.id,
    contract_id: currentContract.id,
    departure_reason_id: selectedReason,
    exit_date: exitDate,
    indemnities: modifiedIndemnities,
    action,
    settlement_id: finalSettlementData?.id,
  };

  try {
    console.log("Envoi du payload:", payload);
    await apiService.saveElement("/final_settlement", payload);
    action === "validate"
      ? notify("Solde tout compte validé", "", 2)
      : action ==="draft" ? notify("Solde tout compte remis en brouillon", "", 2) : notify("Solde tout compte sauvegardé", "", 2);
    setActiveTab && refreshRecap();
  } catch (err) {
    console.error("Erreur lors de l'enregistrement du final settlement", err);
  }
};
 

  return (
    <div className="bg-white min-h-screen p-6 md:p-10">
      <h2 className="text-3xl font-bold mb-8 text-red-500 flex justify-between items-center">Solde tout compte
        <span className={finalSettlementData?.state === "validated" ? "badge text-[var(--color-primary)]" : "badge text-[var(--color-orange)]"}>
          {finalSettlementData?.state === "validated" ? "Validé" : "Brouillon"}
        </span>
      </h2>
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
           
            <div>
              <label className="block mb-1 font-medium">Motif du départ</label>
              <select
                className="select select-bordered w-full"
                value={selectedReason}
                onChange={e => {
                  setSelectedReason(e.target.value);
                }}
              >
                <option value="" disabled>Choisir un motif</option>
                {departureReasons.map(reason => (
                  <option key={reason.id} value={reason.id}>{reason.name}</option>
                ))}
              </select>
            </div>
            <div>
              </div>
            <div>
              <label className="block mb-1 font-medium">Date d'entrée</label>
              <input 
                type="date" 
                className="input input-bordered w-full" 
                value={currentContract.DateStart}
                readOnly 
              />
            </div>
            {/* <div>
              <label className="block mb-1 font-medium">Date de sortie initialement prevu</label>
              <input 
                type="date" 
                className="input input-bordered w-full"
              />
            </div> */}
            <div>
              <label className="block mb-1 font-medium">Date de sortie</label>
              <input
                type="date"
                className="input input-bordered w-full"
                value={exitDate}
                onChange={e => setExitDate(e.target.value)}
              />
            </div>
          </div>
          <div className="flex gap-8 items-center mb-8 justify-between">
              <h3 className="text-lg font-bold">Récapitulatif des indemnités</h3>
              <button
                type="button"
                className="btn btn-outline text-[--color-primary] hover:bg-[--color-primary] hover:text-white"
                onClick={recalculateIndemnities}
              >
                Calculer
              </button>
          </div>
          
          <div>
            {indemnities.map((item, index) => (
             <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8 bg-gray-50 rounded-lg p-4">
                <span className="font-medium">{item.label}</span>
                <input
                  type="number"
                  placeholder="Montant"
                  className="input input-bordered"
                  min={0}
                  value={item.amount}
                  onChange={e => handleIndemnityChange(index, "amount", e.target.value)}
                />
                {/* {indemnities.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-xs btn-circle btn-outline btn-error"
                    title="Supprimer"
                    onClick={() => handleRemoveIndemnity(index)}
                  >×</button>
                )} */}
              </div>
            ))}
          </div>
          {/* Boutton pour a */}
          {/* <button
            type="button"
            className="text-[--color-primary] mt-2 mb-8 flex items-center gap-1"
            onClick={handleAddIndemnity}
          >
            <span className="text-xl font-bold">+</span>
            <span className="underline">Ajouter une indemnité</span>
          </button> */}

          {/* Solde à verser */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8 bg-gray-50 rounded-lg p-4">
            <span className="font-bold text-xl">Solde à verser</span>
            <span className="font-bold text-2xl text-[--color-primary]">
              {indemnities.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0).toLocaleString("fr-FR")} FCFA
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="mb-8">
              <h3 className="text-lg font-bold mb-4">Options & Documents</h3>
              <div className="flex flex-col gap-4 mb-4">
                <label className="block font-medium">Mode de paiement</label>
                <select className="select select-bordered w-full" defaultValue="">
                  <option value="" disabled>Choisir le mode de paiement</option>
                  <option>Virement bancaire</option>
                  <option>Chèque</option>
                  <option>Espèces</option>
                </select>
              </div>
              <div className="mb-4">
                <label className="block mb-1 font-medium">Joindre les documents justificatifs</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center text-center cursor-pointer hover:border-[--color-primary] transition">
                  <span className="text-[--color-primary] font-semibold">Cliquez pour télécharger</span>
                  <span className="text-xs text-gray-500">ou faites glisser et déposez</span>
                  <span className="text-xs text-gray-400 mt-1">(Taille max. du fichier : 25 Mo)</span>
                  <input type="file" className="hidden" />
                </div>
              </div>
              <button type="button" className="btn bg-[--color-primary] hover:bg-[--bg-hover] text-white w-fit">Générer le PDF</button>
            </div>
            <div className="form-control mb-8">
              <h3 className="text-lg font-bold mb-4">Validation & Signature</h3>
              <label className="label cursor-pointer flex items-center mb-4 gap-2">
                <input
                  type="checkbox"
                  className="checkbox checkbox-[--color-primary]"
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                />
                <span className="label-text font-medium">
                  L’employé a pris connaissance du solde de tout compte et l’a signé
                </span>
              </label>
              <textarea
                placeholder="Signature"
                className="textarea textarea-bordered mt-6"
                rows={6}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-4 mt-8">
        {!isDraft ? (
          <>
            <button
              type="button"
              className="btn btn-outline text-[--color-primary] hover:bg-[--color-primary]"
              onClick={handleFinalSettlement("draft")}
            >
              Remettre en brouillon
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("Contrats")}
              className="btn btn-outline btn-error"
            >
              Retour
            </button>
          </>
        ) : (
          <>
            <button 
              type="button" 
              className="btn btn-outline text-[--color-primary] hover:bg-[--color-primary]"
              onClick={handleFinalSettlement("save")}
            >
              Sauvegarder
            </button>
            <button  
              onClick={handleFinalSettlement("validate")}
              type="submit"
              className="btn bg-[--color-primary] text-white hover:bg-[--bg-hover]"
            >
              Valider
            </button>
            <button
              type="button"
              onClick={finalSettlementId ? handleDeleteFinalSettlement : () => setActiveTab("Contrats")}
              className="btn btn-outline btn-error"
            >
              Supprimer
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default FinalSettlement;